/* eslint-disable better-mutation/no-mutation */
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { PossibleItemTypes } from '../item-card/item-card';

type QuickViewState = {
    item?: PossibleItemTypes | null;
    items?: PossibleItemTypes[] | null;
    isOpen: boolean;
    openedFrom?: string | null;
};

export const initialState: QuickViewState = {
    isOpen: false
};

export const quickView = createSlice({
    name: 'quickView',
    initialState,
    reducers: {
        openQuickView: (
            state,
            {
                payload
            }: PayloadAction<{
                item?: PossibleItemTypes;
                items?: PossibleItemTypes[] | null;
                openedFrom?: string;
            }>
        ) => {
            const {
                items = state.items,
                item = state.item,
                openedFrom
            } = payload;

            state.item = item;
            state.items = items;
            state.isOpen = true;
            state.openedFrom = openedFrom;
        },
        closeQuickView: (state) => {
            state.item = null;
            state.items = null;
            state.isOpen = false;
            state.openedFrom = null;
        }
    }
});

export const { openQuickView, closeQuickView } = quickView.actions;

export default quickView.reducer;
